var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFireExtinguisher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M18.6,36.7c2,1.1,4.4,1.1,6.4,0c0.6-0.3,0.9-0.9,0.9-1.5V17.4c0-1.4-0.7-2.7-1.9-3.4l-0.6-0.3v-0.5 c0.5-0.1,0.9-0.4,1.1-0.8l4.1,2.1c0.5,0.2,1.1,0,1.4-0.5c0.2-0.5,0-1.1-0.5-1.4l0,0L25,10.4l3.4-0.8c0.5-0.1,0.8-0.5,0.8-1V8.4 c0-0.3-0.2-0.5-0.4-0.6c-0.2-0.2-0.5-0.2-0.8-0.2l-6.1,1.4h-0.1c-0.8-0.1-1.5,0.5-1.6,1.3c-2.9,0.5-5,3-5,5.9v10.6 c-0.2,0.2-0.3,0.5-0.3,0.8v3.3c0,0.2,0.2,0.3,0.4,0.3h1.8c0.1,0,0.1-0.1,0.1-0.2v-3.4c0-0.2-0.1-0.5-0.2-0.7V16.4 c0-1.9,1.3-3.6,3.2-4v1.3L19.6,14c-1.2,0.7-1.9,2-1.9,3.4v17.8C17.7,35.8,18,36.4,18.6,36.7z M18.9,29.8h-0.5v-0.6h0.3 c2,0.6,4.2,0.6,6.2,0h0.3v0.6h-0.5C22.8,30.4,20.8,30.4,18.9,29.8z M18.4,28.5V26h0.3c2,0.6,4.2,0.6,6.2,0h0.3v2.4h-0.5 c-1.9,0.6-3.9,0.7-5.8,0.1L18.4,28.5z M21.1,11.6c0,0.9,0.7,1.6,1.6,1.7v0.9l0,0c-0.5,0.4-1.3,0.4-1.8,0l0,0v-3.6 c0-0.5,0.4-0.9,0.9-0.9c0,0,0,0,0,0h0.5C21.5,9.9,21,10.7,21.1,11.6z M29.2,13.2c0.1,0,0.2,0.2,0.1,0.4h-0.4l-4.1-2v-0.6L29.2,13.2z  M23.3,9.4l4.9-1.1c0.2,0,0.3,0.1,0.3,0.3c0,0,0,0,0,0l0,0c0,0.2-0.1,0.3-0.2,0.3l-4.3,1l-0.6-0.4L23.3,9.4z M15.9,27.2h0.2 c0.2,0,0.4,0.3,0.4,0.5v2.9h-0.9v-3C15.6,27.5,15.7,27.2,15.9,27.2L15.9,27.2z M16.3,16.4v10H16V16.2c0-2.5,1.7-4.7,4.2-5.1v0.5 C17.9,12,16.3,14,16.3,16.4z M18.4,17.4c0-1.2,0.6-2.2,1.6-2.8h0.2l0.3,0.4c0.8,0.5,1.7,0.5,2.5,0c0.2-0.1,0.3-0.3,0.4-0.4h0.2 c0.5,0.3,0.9,0.7,1.2,1.2c0.2,0.5,0.4,1,0.4,1.6V20h-0.5c-1.9,0.6-3.9,0.6-5.8,0h-0.5V17.4z M18.9,25.5h-0.5v-4.7h0.3 c2,0.6,4.2,0.6,6.2,0h0.3v4.6h-0.5C22.8,26,20.8,26,18.9,25.5z M18.4,35.1v-4.7h0.3c2,0.6,4.2,0.7,6.2,0.1h0.3v4.7 c0,0.4-0.2,0.7-0.5,0.9l0,0c-1.8,0.9-4,0.9-5.8,0C18.6,35.9,18.4,35.5,18.4,35.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M20.2,11.1c-2.5,0.4-4.2,2.6-4.2,5.1v10.2h0.3v-10c0-2.3,1.6-4.3,3.9-4.8V11.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#A1A1A1",
    d: "M20.9,10.6v3.6l0,0c0.5,0.4,1.3,0.4,1.8,0l0,0v-0.9c-0.9-0.1-1.6-0.8-1.6-1.7c-0.1-0.8,0.4-1.6,1.2-1.9h-0.5 C21.3,9.6,20.9,10.1,20.9,10.6C20.9,10.6,20.9,10.6,20.9,10.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#A1A1A1",
    d: "M15.6,30.5h0.9v-2.9c0-0.2-0.2-0.5-0.4-0.5h-0.3c-0.1,0-0.2,0.2-0.2,0.3V30.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M25.2,29.8v-0.6h-0.3c-2,0.6-4.2,0.6-6.2,0h-0.3v0.6h0.5c1.9,0.6,3.9,0.6,5.8,0H25.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M24.7,25.5h0.5v-4.7h-0.3c-2,0.6-4.2,0.6-6.2,0h-0.3v4.6h0.5C20.8,26,22.8,26,24.7,25.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M24.7,28.5h0.5V26h-0.3c-2,0.6-4.2,0.6-6.2,0h-0.3v2.4h0.5C20.8,29.1,22.8,29.1,24.7,28.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2724A",
    d: "M18.9,36c1.8,0.9,4,0.9,5.8,0l0,0c0.3-0.2,0.5-0.5,0.5-0.9v-4.7h-0.3c-2,0.6-4.2,0.6-6.2,0h-0.3v4.7 C18.4,35.5,18.6,35.9,18.9,36z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2724A",
    d: "M18.9,20.2c1.9,0.6,3.9,0.6,5.8,0h0.5v-2.8c0-0.6-0.2-1.1-0.4-1.6c-0.3-0.5-0.7-0.9-1.2-1.2h-0.2 c-0.1,0.1-0.2,0.3-0.4,0.4c-0.8,0.5-1.7,0.5-2.5,0l-0.3-0.4H20c-1,0.6-1.6,1.6-1.6,2.8V20L18.9,20.2z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M24,9.9l4.3-1c0.1,0,0.2-0.1,0.2-0.3l0,0c0-0.2-0.1-0.3-0.3-0.3l0,0l-4.9,1.1h0.1L24,9.9z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M24.8,11.6l4.1,2.1h0.4c0.1-0.2,0-0.4-0.1-0.4l-4.4-2.3V11.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireExtinguisher);
export default __webpack_public_path__ + "static/media/fire_extinguisher.2f3d50a0eb39403ed12bf3280d7fb17b.svg";
export { ForwardRef as ReactComponent };